import { Component, EventEmitter, OnInit, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Table } from 'primeng/table';
import { PlanoDeContasService } from '../../../services/plano-de-contas.service';
import { ContaContabil } from '../../../models/contaContabil.model';
import { NaturezaContaContabil } from '../../../models/enums/naturezaContaContabil.enum';
import { TipoContaContabil } from '../../../models/enums/tipoContaContabil.enum';
import { ConfirmationService } from 'primeng/api';
import { SpinnerService } from '../../../services/spinner.service';
import { ToastService } from '../../../services/toast.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { Router } from '@angular/router';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { AuthService } from '../../../services/auth.service';
import { Icones } from '../../../shared/variaveisDeRotas';
import { descricaoTipoTransacaoContabil, TipoTransacaoContabil } from '../../../models/enums/tipoTransacaoContabil.enum';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { FormataValorPositivo } from '../../../helpers/formata-valor-positivo.helper';
import { retornaDescricao } from '../../../shared/mock/descricao';

@Component({
  selector: 'app-plano-de-conta-listagem',
  templateUrl: './plano-de-contas-listagem.component.html',
  styleUrl: './plano-de-contas-listagem.component.scss',
  providers: [ConfirmationService]
})
export class PlanoDeContasListagemComponent implements OnInit {

  @ViewChild('dt') dt: Table | undefined;
  @ViewChildren('dt') tables!: QueryList<Table>;

  filtroTipoSelecionado: TipoContaContabil | null = null;
  activeTabIndex: number = 0;

  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  listaContasContabeis: ContaContabil[];
  groupByNatureza: any;
  groupByNaturezaOriginal: { [key: string]: ContaContabil[] } = {};
  nomeColunaSaldo: string;
  private userId: string;
  selectedNatureza: string;
  naturezaSaldoOptions: { tipo: number; nome: string }[] = [];
  loading: boolean = false;
  
  editandoNovaConta: boolean = false;
  contaPaiSelecionada: ContaContabil | null = null;
  novaConta: {
    descricao: string;
    saldoAnteriorCadastro: number | null;
    tipoTransacaoSaldoAnteriorCadastro: number | null;
  } = {
    descricao: '',
    saldoAnteriorCadastro: null,
    tipoTransacaoSaldoAnteriorCadastro: null
  };

  editandoContaExistente: boolean = false;
  contaEmEdicao: ContaContabil | null = null;
  contaOriginal: any = null;

  valorEditavelSaldo: { [key: string]: number } = {};

  statuses!: any[];

  constructor(
    private planoDeContasService: PlanoDeContasService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    public spinnerService: SpinnerService,
    private toastService: ToastService,
    private router: Router,
    private jwtHelper: JwtHelper,
    public formataValorPositivoHelper: FormataValorPositivo
  ) {
    this.userId = this.jwtHelper.getUserIdFromToken();
  }

  ngOnInit(): void {
    this.tituloChange.emit('Lista de Planos de Contas');
    this.iconeChange.emit(Icones.listaTopicoAmarelo);
    this.tituloDescricao.emit(retornaDescricao('planoDeContas').titulo);
    this.textoDescricao.emit(retornaDescricao('planoDeContas').texto);
    this.mostrarDescricao.emit(true)
    this.carregaPlanoDeContas();
    this.retornaDataPorUsuarioId(this.userId);

    this.naturezaSaldoOptions = [
      {
        tipo: TipoTransacaoContabil.Debito,
        nome: "D", 
      },
      {
        tipo: TipoTransacaoContabil.Credito,
        nome: "C",
      },
    ];

    this.statuses = [
      { label: 'Unqualified', value: 'unqualified' },
      { label: 'Qualified', value: 'qualified' },
      { label: 'New', value: 'new' },
      { label: 'Negotiation', value: 'negotiation' },
      { label: 'Renewal', value: 'renewal' },
      { label: 'Proposal', value: 'proposal' }
    ];
  }

  tiposContas = [
    { label: 'Todos', value: null },
    { label: 'Analítico', value: TipoContaContabil.A },
    { label: 'Sintético', value: TipoContaContabil.S }
  ];

  filtrarPorTipo(): void {
    if (this.filtroTipoSelecionado === null) {
      this.groupByNatureza = Object.values(this.groupByNaturezaOriginal);
      return;
    }

    const filtrado: { [key: string]: ContaContabil[] } = {};

    for (const natureza in this.groupByNaturezaOriginal) {
      const contas = this.groupByNaturezaOriginal[natureza];
      const contasFiltradas = contas.filter(c => c.tipo === this.filtroTipoSelecionado);

      if (contasFiltradas.length > 0) {
        filtrado[natureza] = contasFiltradas;
      }
    }

    this.groupByNatureza = Object.values(filtrado);
  }


  aoTrocarAba() {
    if (this.filtroTipoSelecionado !== null) {
      this.filtrarPorTipo();
    }
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }

  retornaDataPorUsuarioId(userId: string) {
    this.authService.retornarDataVerificacaoEmailUsuario(userId).subscribe({
      next: (res) => {
        this.nomeColunaSaldo = this.formatarDataSaldo(res);
      },
      error: (e) => {
      }
    })
  }

  formatarDataSaldo(dataString: string): string {
    const data = new Date(dataString);

    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const ano = data.getFullYear();

    return `Saldo até ${mes}/${ano}`;
  }

  adicionarContaContabil(contaContabilPai: ContaContabil): void {
    this.editandoNovaConta = true;
    this.contaPaiSelecionada = contaContabilPai;
    this.novaConta = {
      descricao: '',
      saldoAnteriorCadastro: null,
      tipoTransacaoSaldoAnteriorCadastro: null
    };
  }

  editarContaContabil(contaContabil: ContaContabil): void {
    this.editandoContaExistente = true;
    this.contaEmEdicao = Object.assign({}, contaContabil);
    this.contaOriginal = Object.assign({}, contaContabil);
  }

  excluirContaContabil(contaContabilId: number): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja deletar conta contábil?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.spinnerService.show('Excluindo conta contábil...');
        this.planoDeContasService.deletePlanoDeContas(contaContabilId).subscribe({
          next: () => {
            this.toastService.setMensagemToast('Conta contábil excluída com sucesso.', SeveridadeToast.Success);
            this.carregaPlanoDeContas();
            this.spinnerService.hide();
          },
          error: (e) => {
            console.error('Erro ao excluir conta contábil:', e);
            this.toastService.setMensagemToast(`Erro ao excluir conta contábil: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
            this.spinnerService.hide();
          }
        });
      },
    });
  }

  carregaPlanoDeContas() {
    this.loading = true;
    this.spinnerService.show('Carregando plano de contas...');
    this.planoDeContasService.getContasContabeis(this.userId).subscribe({
      next: (res) => {
        this.listaContasContabeis = res.map(conta => {
          if (conta.tipoTransacaoSaldoAnteriorCadastro === 0 as any) {
            conta.tipoTransacaoSaldoAnteriorCadastro = TipoTransacaoContabil.Credito;
          }

          if (conta.saldoAnteriorCadastro === null || conta.saldoAnteriorCadastro === undefined || conta.saldoAnteriorCadastro === 0) {
            conta.tipoTransacaoSaldoAnteriorCadastro = null;
          }

          else if (conta.tipoTransacaoSaldoAnteriorCadastro === null || conta.tipoTransacaoSaldoAnteriorCadastro === undefined) {
            conta.tipoTransacaoSaldoAnteriorCadastro = TipoTransacaoContabil.Debito;
          }
          if (conta.saldoAnteriorCadastro === 0) {
            conta.saldoAnteriorCadastro = null;
          }

          return conta;
        });

        const groupByNatureza = this.listaContasContabeis.reduce((acc, current) => {
          const key = current.natureza;
          if (!acc[key]) acc[key] = [];
          acc[key].push(current);
          return acc;
        }, {} as { [key: string]: ContaContabil[] });

        this.groupByNaturezaOriginal = groupByNatureza;
        this.calcularSaldosContasSinteticas();

        if (this.filtroTipoSelecionado !== null) {
          this.filtrarPorTipo();
        } else {
          this.groupByNatureza = Object.values(this.groupByNaturezaOriginal);
        }

        this.loading = false;
        this.spinnerService.hide();
      },
      error: (e) => {
        console.error('Erro ao carregar plano de contas:', e);
        this.toastService.setMensagemToast('Erro ao carregar plano de contas', SeveridadeToast.Error);
        this.loading = false;
        this.spinnerService.hide();
      }
    });
  }


  verificaSePaiMaiorNivel(planoDeContas: any, contaContabil: any): boolean {
    const temContasFilhas = this.listaContasContabeis.some(conta => 
      conta.contaSuperior === contaContabil.codigo
    );
    
    if (temContasFilhas) {
      return false; 
    }
    return true;
  }

  podeEditarConta(contaContabil: any): boolean {

    const temContasFilhas = this.listaContasContabeis.some(conta => 
      conta.contaSuperior === contaContabil.codigo
    );
    
    if (temContasFilhas) {
      return false;
    }

    return !contaContabil.maiorNivel;
  }

  podeEditarSaldoNatureza(contaContabil: any): boolean {
    const temContasFilhas = this.listaContasContabeis.some(conta => 
      conta.contaSuperior === contaContabil.codigo
    );
    
    if (temContasFilhas) {
      return false; 
    }

    return true;
  }

  retornaNaturezaTexto(natureza: number): string {
    switch (natureza) {
      case NaturezaContaContabil.Ativo:
        return 'Ativo';
      case NaturezaContaContabil.Passivo:
        return 'Passivo';
      case NaturezaContaContabil.PL:
        return 'Patrimônio Líquido';
      case NaturezaContaContabil.Resultado:
        return 'Resultado Líquido do Período';
      default:
        return 'Desconhecido';
    }
  }

  formatarValor(valor: string | number | undefined): string {
    if (valor == null || valor === '') {
      return "0,00";
    }

    if (typeof valor === 'string') {
      valor = parseFloat(valor.replaceAll('.', '').replace(',', '.'));
    }

    if (isNaN(valor)) {
      return "0,00";
    }

    return valor
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  alterarNaturezaSaldo(event: DropdownChangeEvent, contaContabil: ContaContabil): void {
    const novaNatureza = event.value;

    this.listaContasContabeis = this.listaContasContabeis.map(conta =>
      conta.id === contaContabil.id ? { ...conta, tipoTransacaoSaldoAnteriorCadastro: novaNatureza } as ContaContabil : conta
    );

    contaContabil.tipoTransacaoSaldoAnteriorCadastro = novaNatureza;

    this.confirmaAlteracao(event, contaContabil);
  }

  salvarValorOriginal(contaContabil: ContaContabil): void {
    (contaContabil as any).valorOriginalSaldo = contaContabil.saldoAnteriorCadastro;
    (contaContabil as any).valorOriginalNatureza = contaContabil.tipoTransacaoSaldoAnteriorCadastro;
  }

  getAbsoluteValue(value: number): number {
    return value ? Math.abs(value) : 0;
  }

  formatarValorExibicao(value: number): string {
    if (value === null || value === undefined) {
      return 'R$ 0,00';
    }
    
    const valorAbsoluto = Math.abs(value);
    return valorAbsoluto.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  getValorEditavel(contaContabil: ContaContabil): number {
    const valor = contaContabil.saldoAnteriorCadastro;
    if (valor === null || valor === undefined) {
      return 0;
    }
    return Math.abs(valor);
  }

  onValorEditavelChange(event: any, contaContabil: ContaContabil): void {
    const valorDigitado = event.value || 0;
    const valorAbsoluto = Math.abs(valorDigitado);
    
    if (contaContabil.tipoTransacaoSaldoAnteriorCadastro === TipoTransacaoContabil.Credito) {
      contaContabil.saldoAnteriorCadastro = -valorAbsoluto;
    } else {
      contaContabil.saldoAnteriorCadastro = valorAbsoluto;
    }
  }

  onNaturezaChange(event: DropdownChangeEvent, contaContabil: ContaContabil): void {
    const novaNatureza = event.value;
    const valorAtual = contaContabil.saldoAnteriorCadastro;
    
    if (valorAtual !== null && valorAtual !== undefined) {
      const valorAbsoluto = Math.abs(valorAtual);

      if (novaNatureza === TipoTransacaoContabil.Credito) {
        contaContabil.saldoAnteriorCadastro = -valorAbsoluto;
      } else {
        contaContabil.saldoAnteriorCadastro = valorAbsoluto;
      }
    }
    
    this.confirmaAlteracao(event, contaContabil);
  }

  getValorEditavelNovaConta(): number {
    const valor = this.novaConta.saldoAnteriorCadastro;
    if (valor === null || valor === undefined) {
      return 0;
    }
    return Math.abs(valor);
  }

  condicinaisParaAdicao(contaContabil: any, nivel: number): boolean {
    return contaContabil.maiorNivel === true || this.isContaOriginalNivelMaximo(contaContabil);
  }

  confirmaAlteracao(event: Event | DropdownChangeEvent, contaContabil: ContaContabil): void {
    let inputValue: any;
    let houveMudanca = false;

    const valorOriginalSaldo = (contaContabil as any).valorOriginalSaldo;
    const valorOriginalNatureza = (contaContabil as any).valorOriginalNatureza;

    if ('value' in event) {
      inputValue = (event as DropdownChangeEvent).value;
      if (valorOriginalNatureza !== inputValue) {
        houveMudanca = true;
      }
    } else {
      inputValue = contaContabil.saldoAnteriorCadastro;
      if (valorOriginalSaldo !== inputValue) {
        houveMudanca = true;
      }
    }

    let novoSaldo: number;

    if ('value' in event) {
    } else {
      novoSaldo = typeof inputValue === 'number' ? inputValue : this.extrairValor(inputValue);

      contaContabil.saldoAnteriorCadastro = novoSaldo;
    }

    if (!houveMudanca) {
      delete (contaContabil as any).valorOriginalSaldo;
      delete (contaContabil as any).valorOriginalNatureza;
      return;
    }

    if (contaContabil.saldoAnteriorCadastro === null || contaContabil.saldoAnteriorCadastro === undefined) {
      this.toastService.setMensagemToast('Preencha o Saldo Anterior para continuar.', SeveridadeToast.Warn);
      return;
    }

    if (!contaContabil.tipoTransacaoSaldoAnteriorCadastro) {
      this.toastService.setMensagemToast('Selecione a Natureza Saldo para confirmar.', SeveridadeToast.Warn);
      return;
    }

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja alterar o saldo anterior da conta contábil?',
      header: 'Confirmar alteração do saldo anterior',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.spinnerService.show('Editando conta contábil...');

        this.planoDeContasService.atualizarSaldoAnteriorCadastro(contaContabil, this.userId).subscribe({
          next: () => {
            this.carregaPlanoDeContas();
            this.toastService.setMensagemToast('Conta contábil editada com sucesso.', SeveridadeToast.Success);
            this.spinnerService.hide();
          },
          error: (e) => {
            this.carregaPlanoDeContas();
            this.toastService.setMensagemToast(`Erro ao editar conta contábil: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
            this.spinnerService.hide();
          }
        });
      },
      reject: () => {
        if (valorOriginalSaldo !== undefined) {
          contaContabil.saldoAnteriorCadastro = valorOriginalSaldo;
        }
        if (valorOriginalNatureza !== undefined) {
          contaContabil.tipoTransacaoSaldoAnteriorCadastro = valorOriginalNatureza;
        }
        delete (contaContabil as any).valorOriginalSaldo;
        delete (contaContabil as any).valorOriginalNatureza;
      }
    });
  }

  extrairValor(valorString: string): number {
    if (typeof valorString !== 'string') {
      return 0;
    }

    const valorLimpo = valorString.replace(/\./g, '').replace('R$', '').trim().replace(',', '.');

    const valorFinal = parseFloat(valorLimpo);

    if (isNaN(valorFinal)) {
      return 0;
    }

    return valorFinal;
  }

  retornaTipo(tipo: number): string {
    switch (tipo) {
      case TipoContaContabil.A:
        return 'Analítico';
      case TipoContaContabil.S:
        return 'Sintético';
      default:
        return 'Desconhecido';
    }
  }

  verificaUltimoNivel(contaContabil: any): boolean {
    const temContasFilhas = this.listaContasContabeis.some(conta => 
      conta.contaSuperior === contaContabil.codigo
    );
    
    if (temContasFilhas) {
      return false;
    }
    
    return true;
  }

  temContasFilhas(contaContabil: any): boolean {
    const filhas = this.listaContasContabeis.filter(conta => conta.contaSuperior === contaContabil.codigo);
    const temFilhas = filhas.length > 0;
    
    return temFilhas;
  }

  isContaSintetica(contaContabil: any): boolean {
    return this.temContasFilhas(contaContabil) || contaContabil.tipo === 2;
  }

  isContaOriginalNivelMaximo(contaContabil: any): boolean {
    const contasOriginaisNivelMaximo = [
      '2.03.01.01.01', 
      '2.03.01.01.21', 
      '2.03.04.01.01', 
      '2.03.04.01.10', 
      '2.03.04.01.11', 
      
    ];
    
    return contasOriginaisNivelMaximo.includes(contaContabil.codigo);
  }

  podeTerAcoes(contaContabil: any): boolean {
    const isSintetica = this.isContaSintetica(contaContabil);

    const isContaOriginalNivelMaximo = this.isContaOriginalNivelMaximo(contaContabil);

    const podeTer = contaContabil.maiorNivel || isContaOriginalNivelMaximo || (!isSintetica && !contaContabil.maiorNivel && !isContaOriginalNivelMaximo);
    
    return podeTer;
  }

  salvarNovaConta(): void {
    if (!this.novaConta.descricao.trim()) {
      this.toastService.setMensagemToast('Descrição é obrigatória.', SeveridadeToast.Warn);
      return;
    }

    // Removida validação obrigatória do saldo - permite criar conta sem saldo inicial
    // if (this.novaConta.saldoAnteriorCadastro === null || this.novaConta.saldoAnteriorCadastro === undefined) {
    //   this.toastService.setMensagemToast('Saldo é obrigatório.', SeveridadeToast.Warn);
    //   return;
    // }

    if (this.novaConta.tipoTransacaoSaldoAnteriorCadastro === null || this.novaConta.tipoTransacaoSaldoAnteriorCadastro === undefined) {
      this.toastService.setMensagemToast('Natureza é obrigatória.', SeveridadeToast.Warn);
      return;
    }

    this.spinnerService.show('Validando obrigatoriedades...');
    this.planoDeContasService.validarObrigatoriedadesContaContabilSelecionada(this.contaPaiSelecionada!.id, this.userId).subscribe({
      next: (res) => {
        this.spinnerService.show('Salvando nova conta...');

        const novaContaContabil: Partial<ContaContabil> = {
          codigo: res.codigo, 
          descricao: this.novaConta.descricao.trim(),
          saldoAnteriorCadastro: this.novaConta.saldoAnteriorCadastro ? Math.abs(this.novaConta.saldoAnteriorCadastro) : null,
          tipoTransacaoSaldoAnteriorCadastro: this.novaConta.tipoTransacaoSaldoAnteriorCadastro,
          contaSuperior: res.contaSuperior,
          nivel: res.nivel, 
          tipo: res.tipo,
          natureza: res.natureza,
          maiorNivel: false, 
          usuarioId: this.userId
        };

        this.planoDeContasService.addContaContabil(novaContaContabil).subscribe({
          next: () => {
            this.toastService.setMensagemToast('Conta criada com sucesso.', SeveridadeToast.Success);
            this.cancelarNovaConta();
            this.carregaPlanoDeContas();
            this.spinnerService.hide();
          },
          error: (e) => {
            this.toastService.setMensagemToast(`Erro ao criar conta: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
            this.spinnerService.hide();
          }
        });
      },
      error: (e) => {
        this.toastService.setMensagemToast(`Erro ao validar obrigatoriedades: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
        this.spinnerService.hide();
      }
    });
  }

  calcularSaldosContasSinteticas(): void {
    const contasSinteticas = this.listaContasContabeis.filter(conta => 
      this.temContasFilhas(conta)
    );
    
    contasSinteticas.forEach(contaSintetica => {
      this.recalcularSaldoContaSuperior(contaSintetica);
      
      if (contaSintetica.saldoAnteriorCadastro !== null && contaSintetica.saldoAnteriorCadastro !== undefined) {
        contaSintetica.tipoTransacaoSaldoAnteriorCadastro = contaSintetica.saldoAnteriorCadastro >= 0 
          ? TipoTransacaoContabil.Debito 
          : TipoTransacaoContabil.Credito;
      }
    });
    
    const contasAnaliticas = this.listaContasContabeis.filter(conta => 
      conta.saldoAnteriorCadastro !== null && conta.saldoAnteriorCadastro !== undefined
    );
    
    contasAnaliticas.forEach(contaAnalitica => {
      this.propagarSaldoParaContasSuperiores(contaAnalitica);
    });
  }

  private propagarSaldoParaContasSuperiores(contaContabil: ContaContabil): void {
    let contaAtual = contaContabil;
    
    while (contaAtual.nivel > 1) {
      const contaSuperior = this.listaContasContabeis.find(conta => 
        conta.codigo === contaAtual.contaSuperior
      );
      
      if (!contaSuperior) break;
      
      this.recalcularSaldoContaSuperior(contaSuperior);
      
      if (contaSuperior.saldoAnteriorCadastro !== null && contaSuperior.saldoAnteriorCadastro !== undefined) {
        contaSuperior.tipoTransacaoSaldoAnteriorCadastro = contaSuperior.saldoAnteriorCadastro >= 0 
          ? TipoTransacaoContabil.Debito 
          : TipoTransacaoContabil.Credito;
      }
      contaAtual = contaSuperior;
    }
  }

  private recalcularSaldoContaSuperior(contaSuperior: ContaContabil): void {
    const contasFilhas = this.listaContasContabeis.filter(filha => 
      filha.contaSuperior === contaSuperior.codigo
    );
    
    const saldoTotal = contasFilhas.reduce((total, filha) => {
      return total + (filha.saldoAnteriorCadastro || 0);
    }, 0);
    
    contaSuperior.saldoAnteriorCadastro = saldoTotal;
    
    if (saldoTotal === 0) {
      contaSuperior.saldoAnteriorCadastro = null;
    }
  }

  cancelarNovaConta(): void {
    this.editandoNovaConta = false;
    this.contaPaiSelecionada = null;
    this.novaConta = {
      descricao: '',
      saldoAnteriorCadastro: null,
      tipoTransacaoSaldoAnteriorCadastro: null
    };
  }

  salvarEdicaoConta(): void {
    if (!this.contaEmEdicao) return;

    if (!this.contaEmEdicao.descricao || this.contaEmEdicao.descricao.trim() === '') {
      this.toastService.setMensagemToast('A descrição é obrigatória.', SeveridadeToast.Warn);
      return;
    }

    if (this.contaEmEdicao.saldoAnteriorCadastro === null || this.contaEmEdicao.saldoAnteriorCadastro === undefined) {
      this.toastService.setMensagemToast('O saldo é obrigatório.', SeveridadeToast.Warn);
      return;
    }

    if (!this.contaEmEdicao.tipoTransacaoSaldoAnteriorCadastro) {
      this.toastService.setMensagemToast('A natureza é obrigatória.', SeveridadeToast.Warn);
      return;
    }

    this.spinnerService.show('Salvando alterações...');

    this.planoDeContasService.updatePlanoDeContas(this.contaEmEdicao).subscribe({
      next: () => {
        this.carregaPlanoDeContas();
        this.cancelarEdicaoConta();
        this.toastService.setMensagemToast('Conta contábil atualizada com sucesso.', SeveridadeToast.Success);
        this.spinnerService.hide();
      },
      error: (e) => {
        this.carregaPlanoDeContas();
        this.cancelarEdicaoConta();
        this.toastService.setMensagemToast(`Erro ao atualizar conta contábil: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
        this.spinnerService.hide();
      }
    });
  }

  cancelarEdicaoConta(): void {
    this.editandoContaExistente = false;
    this.contaEmEdicao = null;
    this.contaOriginal = null;
  }

  applyFilterGlobal(filterValue: string): void {
    if (this.tables && this.tables.length > 0) {
      this.tables.forEach(table => {
        table.filterGlobal(filterValue, 'contains');
      });
    }
  }
}
